const PopupKind = Object.freeze({
  // 사실 이렇게 하면 그대로 문자열 비교가 되기 때문에 좀 더 Enumerations 처럼 사용하려면
  // Symbol 을 이용하는게 좋음. 하지만 Symbol 을 사용할 경우 다른 언어와 달리 rowValue 를
  // 따로 추출이 안 되는 것 같음. 이 값 자체를 타이틀바에 메시지로 가져가 사용하기 위해
  // Symbol 없이 사용함.
  CREATE: "추가",
  UPDATE: "수정",
  // DELETE: "삭제",
});

export { PopupKind };
